import { Link } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";

export const TaskTypeBackLink = () => {
  const { t } = useTranslation(["TaskTypes"]);
  return (
    <Link
      to="/duedates/settings/boards"
      type="icon"
      iconCss="fa-regular fa-arrow-left"
    >
      <span>{t("Back")}</span>
    </Link>
  );
};
